/**
 * @shelf-version: 1.0.0
 */

import Toggle from './toggle'

export default Toggle
